const initialState = {
  active: [],
  saved: []
}

// Actions
const LOAD   = 'actions/LOAD';
const SAVE = 'actions/SAVE';
const CREATE = 'actions/CREATE';
const UPDATE = 'actions/UPDATE';
const REMOVE = 'actions/REMOVE';

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SAVE:
      const { active, saved } = state;
      saved.push(action.data)
      return { active, saved }
    default: return state;
  }
}

// Action Creators
export function loadCampaigns() {
  return { type: LOAD };
}

export function saveCampaign(data) {
  return { type: SAVE, data };
}

export function createCampaign(data) {
  return { type: CREATE, data };
}

export function updateCampaign(data) {
  return { type: UPDATE, data };
}

export function removeCampaign(data) {
  return { type: REMOVE, data };
}

// side effects, only as applicable
// e.g. thunks, epics, etc
// export function getCampaign () {
//   return dispatch => get('/data').then(data => dispatch(updateCampaign(data)))
// }


// WEBPACK FOOTER //
// ./src/actions/campaigns.js